import React, { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { Col, Row } from "reactstrap";

import "@/assets/scss/modern-modal.css";
import HistoryList from "@/components/Common/HistoryList";
import InfoRow from "@/components/Common/Inforow";
import TransactionDetailsModal from "@/components/Common/Modals/TransactionDetailsModal";
import Section from "@/components/Common/Section";
import useCustomHook from "@/components/Hooks/useCustomHook";
import { formatDate } from "@/helpers/date_helper";

import ActionModal from "./ActionModal";

import { useGetAccessRequestLogsQuery } from "@/api/Endpoints/Core/Transactions/AccessRequest/AccessRequestLogs";
import { useFindAccessRequestsQuery } from "@/api/Endpoints/Core/Transactions/AccessRequest/AccessRequests";

function TransactionDetailsTab({ data }) {
    return (
        <div style={{ paddingTop: 4 }}>
            <Section title="Request Details">
                <Row>
                    <Col lg={6}>
                        <InfoRow icon="bx bx-user" label="Username" value={data?.userName} />
                    </Col>
                    <Col lg={6}>
                        <InfoRow icon="bx bx-id-card" label="Full Name" value={data?.fullName} />
                    </Col>
                    <Col lg={6}>
                        <InfoRow icon="bx bx-envelope" label="Email Address" value={data?.emailAddress} />
                    </Col>
                    <Col lg={6}>
                        <InfoRow icon="bx bx-phone" label="Mobile No." value={data?.mobileNo} />
                    </Col>
                </Row>
            </Section>

            <Section title="Remarks">
                <Row>
                    <Col lg={12}>
                        <InfoRow icon="bx bx-message-square-detail" label="Remarks" value={data?.remarks} />
                    </Col>
                </Row>
            </Section>

            <Section title="Status Details">
                <Row>
                    <Col lg={6}>
                        <InfoRow label="Date Submitted" value={formatDate(data.dateSubmitted)} icon="ri-calendar-2-line" />
                    </Col>
                    <Col lg={6}>
                        <InfoRow label="Submitted By" value={data.submittedByName} icon="ri-user-3-line" />
                    </Col>
                    <Col lg={6}>
                        <InfoRow label="Date Approved" value={formatDate(data.dateApproved)} icon="ri-calendar-2-line" />
                    </Col>
                    <Col lg={6}>
                        <InfoRow label="Approved By" value={data.approvedByName} icon="ri-user-3-line" />
                    </Col>
                </Row>
            </Section>
        </div>
    );
}

export default function ViewDetails({ show, onCloseClick, data, parentKey, onUpdateParentKey }) {
    if (!show) return null;

    const TABS = useMemo(
        () => [
            { key: "requestInfo", label: "Request Details", icon: "ri-user-line", component: TransactionDetailsTab },
            {
                key: "history", label: "History", icon: "ri-shield-flash-line", component: () =>
                    <HistoryList
                        transactionId={data?.accessRequestId}
                        useLogsQuery={useGetAccessRequestLogsQuery}
                        idKey="accessRequestId"
                        title="History"
                    />
            },
            // {
            //     key: "files", label: "Files", icon: "ri-folder-line", component: () =>
            //         <TransactionFilesList
            //             transactionId={data?.accessRequestId}
            //             useFilesQuery={useGetFilesPrescriptionRequestsQuery}
            //             idKey="accessRequestId"
            //             title="Files"
            //         />
            // },
        ],
        [data?.accessRequestId],
    );

    const { state, customFunction } = useCustomHook({
        tabRefreshKey: 0,
    });

    const { data: transactionData, refetch } = useFindAccessRequestsQuery(
        { accessRequestId: data?.accessRequestId },
        { skip: !data?.accessRequestId, refetchOnMountOrArgChange: show },
    );
    const findData = transactionData?.returnData;

    const { reset, control } = useForm({ defaultValues: {} });

    useEffect(() => {
        reset({
            ...data,
            ...findData,
        });
        customFunction.updateState({
            data: {
                ...data,
                ...findData,
            },
        });
    }, [show, data, findData, refetch, reset]);

    const handleActions = (bool, data) => {
        if (bool) {
            refetch();
            customFunction.updateToggle("toggleAction");
            customFunction.updateState({
                tabRefreshKey: state?.tabRefreshKey + 1,
            });
            onUpdateParentKey(parentKey + 1);
        } else {
            customFunction.updateToggle("toggleAction", { ...findData, actionName: data });
        }
    };

    const BUTTONS = useMemo(
        () => [
            {
                label: "Return",
                icon: "ri-arrow-go-back-line",
                className: "emd-btn-warning",
                show: state?.data?.actions?.return,
                onClick: () => handleActions(false, "Return"),
            },
            {
                label: "Approve",
                icon: "ri-check-double-line",
                className: "emd-btn-success",
                show: state?.data?.actions?.approve,
                onClick: () => handleActions(false, "Approve"),
            },
            {
                label: "Reject",
                icon: "ri-thumb-down-line",
                className: "emd-btn-danger",
                show: state?.data?.actions?.reject,
                onClick: () => handleActions(false, "Reject"),
            },
            {
                label: "Cancel",
                icon: "ri-close-line",
                className: "emd-btn-danger",
                show: state?.data?.actions?.cancel,
                onClick: () => handleActions(false, "Cancel"),
            },
        ],
        [state?.data?.actions],
    );

    return (
        <React.Fragment>
            <ActionModal
                state={state}
                customFunction={customFunction}
                accessRequestId={findData?.accessRequestId}
                data={state?.trxValue}
                show={state.toggle.toggleAction}
                onCloseClick={handleActions}
            />

            <TransactionDetailsModal
                title={"Access Request"}
                show={show}
                data={state.data}
                tabs={TABS}
                buttons={BUTTONS}
                onCloseClick={onCloseClick}
                tabRefreshKey={state.tabRefreshKey}
            />
        </React.Fragment>
    );
};

// return (
//     <React.Fragment>
//         <ActionModal
//             state={state}
//             customFunction={customFunction}
//             accessRequestId={findData?.accessRequestId}
//             data={state?.trxValue}
//             show={state.toggle.toggleAction}
//             onCloseClick={handleActions}
//         />

//         <Modal
//             className="modal-fullscreen"
//             modalClassName="flip"
//             id="requestDetails"
//             size="xl"
//             isOpen={show}
//             toggle={onCloseClick}
//             centered
//             backdrop="static"
//         >
//             <ModalBody>
//                 <div>
//                     <div className="profile-foreground position-relative mx-n4 mt-n4">
//                         <div className="profile-wid-bg">
//                             <picture>
//                                 <source srcSet={profileBg} type="image/jpeg" />
//                                 <img src={profileBg} alt="" className="profile-wid-img" />
//                             </picture>
//                         </div>
//                     </div>
//                     <div className="pt-4 mb-4 mb-lg-3 pb-lg-4">
//                         <Row className="g-4">

//                             <div className="col-md-auto">
//                                 <PhotoViewer>
//                                     <img src={defaultTrxImg} style={{ width: "100px", height: "80px", cursor: 'pointer' }} />
//                                 </PhotoViewer>
//                             </div>

//                             <Col style={{ paddingLeft: "0px" }}>
//                                 <div>
//                                     <h3 className="text-white mb-1">Access Request Details</h3>
//                                     <p className="text-white text-opacity-75">
//                                         Date {state.data?.statusName}:{" "}
//                                         <span className="fw-semibold">
//                                             {(
//                                                 <DateTimeLabel
//                                                     value={state.data?.statusDate}
//                                                 />
//                                             ) || "Draft"}
//                                         </span>{" "}
//                                         <Badge
//                                             value={state.data?.statusName}
//                                             color={state.data?.statusColor}
//                                         />
//                                         <br />
//                                         Reference No. : <span className="fs-16 fw-semibold" style={{ color: '#0ab39c' }}>{findData?.referenceNo}</span>
//                                     </p>
//                                 </div>
//                             </Col>

//                             <Col xs={12} className="col-lg-auto order-last order-lg-0">
//                                 <Row className="text text-white-50 text-center">
//                                     <Col lg={12} xs={12}>
//                                         <div className="col-md-auto">
//                                             <div className="hstack gap-1 flex-wrap mt-4 mt-md-0">
//                                                 <button
//                                                     type="button"
//                                                     className="btn btn-icon btn-sm btn-ghost-danger fs-16"
//                                                     onClick={onCloseClick}
//                                                 >
//                                                     X
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     </Col>
//                                 </Row>
//                             </Col>
//                         </Row>
//                     </div>

//                     <Row>
//                         <Col xxl={12}>
//                             <Card>
//                                 <CardBody>
//                                     <Row>
//                                         <Col lg={6}>
//                                             <Card>
//                                                 <CardBody>
//                                                     <div className="d-flex align-items-center mb-4">
//                                                         <h5 className="card-title flex-grow-1 mb-0">
//                                                             Request Details
//                                                         </h5>
//                                                         <div className="flex-shrink-0">
//                                                             <ReturnButton
//                                                                 isShowButton={state.data?.actions?.return}
//                                                                 onClick={() => {
//                                                                     handleActions(false, "Return");
//                                                                 }}
//                                                             />{" "}
//                                                             <ApproveButton
//                                                                 isShowButton={state.data?.actions?.approve}
//                                                                 onClick={() => {
//                                                                     handleActions(false, "Approve");
//                                                                 }}
//                                                             />{" "}
//                                                             <RejectButton
//                                                                 isShowButton={state.data?.actions?.reject}
//                                                                 onClick={(e) => {
//                                                                     handleActions(false, "Reject");
//                                                                 }}
//                                                             />{" "}
//                                                             <CancelButton
//                                                                 isShowButton={state.data?.actions?.cancel}
//                                                                 onClick={(e) => {
//                                                                     handleActions(false, "Cancel");
//                                                                 }}
//                                                             />
//                                                         </div>
//                                                     </div>
//                                                     <Row>
//                                                         <Col lg={6}>
//                                                             <InputField
//                                                                 disabled
//                                                                 name="userName"
//                                                                 control={control}
//                                                                 label="Username"
//                                                             />
//                                                         </Col>
//                                                         <Col lg={6}>
//                                                             <InputField
//                                                                 disabled
//                                                                 name="fullName"
//                                                                 control={control}
//                                                                 label="Full Name"
//                                                             />
//                                                         </Col>
//                                                         <Col lg={6}>
//                                                             <EmailInputField
//                                                                 disabled
//                                                                 name="emailAddress"
//                                                                 control={control}
//                                                                 label="Email Address"
//                                                             />
//                                                         </Col>
//                                                         <Col lg={6}>
//                                                             <MobileInputField
//                                                                 disabled
//                                                                 name="mobileNo"
//                                                                 control={control}
//                                                                 label="Mobile No."
//                                                             />
//                                                         </Col>
//                                                         <Col lg={12}>
//                                                             <InputField
//                                                                 disabled
//                                                                 rows={4}
//                                                                 name="remarks"
//                                                                 control={control}
//                                                                 label="Remarks"
//                                                                 type="textarea"
//                                                                 placeholder="Remarks here..."
//                                                             />
//                                                         </Col>

//                                                         <div className="col-12">
//                                                             <hr className="pb-2" />
//                                                         </div>

//                                                         <Col lg={6}>
//                                                             <DatePickerField
//                                                                 control={control}
//                                                                 name="dateSubmitted"
//                                                                 label="Date Submitted"
//                                                                 disabled
//                                                             />
//                                                         </Col>
//                                                         <Col lg={6}>
//                                                             <InputField
//                                                                 control={control}
//                                                                 name="submittedByName"
//                                                                 label="Submitted By"
//                                                                 disabled
//                                                             />
//                                                         </Col>
//                                                         {findData?.statusName !== "Submitted" ? (
//                                                             <>
//                                                                 <Col lg={6}>
//                                                                     <DatePickerField
//                                                                         control={control}
//                                                                         name="statusDate"
//                                                                         label={`Date ${findData?.statusName}`}
//                                                                         disabled
//                                                                     />
//                                                                 </Col>
//                                                                 <Col lg={6}>
//                                                                     <InputField
//                                                                         control={control}
//                                                                         name="statusByName"
//                                                                         label={`${findData?.statusName} By`}
//                                                                         disabled
//                                                                     />
//                                                                 </Col>
//                                                             </>
//                                                         ) : null}
//                                                     </Row>
//                                                 </CardBody>
//                                             </Card>
//                                         </Col>

//                                         <Col lg={6}>
//                                             <History
//                                                 key={state.refetchHistory}
//                                                 parentId={data?.accessRequestId}
//                                             />
//                                         </Col>
//                                     </Row>
//                                 </CardBody>
//                             </Card>
//                         </Col>
//                     </Row>
//                 </div>
//             </ModalBody>
//         </Modal>
//     </React.Fragment>
// );